import { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export function useVideoInViewPlayback() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { ref: inViewTargetRef, inView } = useInView();
  const [isVideoManualControl, setIsVideoManualControl] = useState(false);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl) return;
    if (!inView) {
      videoEl.pause();
    } else if (videoEl.paused && !isVideoManualControl) {
      videoEl.play();
    }
  }, [inView, isVideoManualControl]);

  return { inViewTargetRef, videoRef, setIsVideoManualControl };
}
